import gql from "graphql-tag";

export const GET_ELEMENT = gql`
query($title:String!){
    getOneElement(title: $title){
        _id
        title
    }
}
`;

export const GET_CURRENT_USER = gql`
    query{
  getCurrentUser{
    _id
    email    
    NicName
    Name
    Surname
    Birthday
    ETHWallet
    BSCWallet
    Nationality
    Country
    PostalCode
    City
    Address
    MobilePhone
    Skype
    IsAdmin
    TableReferal
      
    PassportVerify 
    AddressVerify 
    BerfusVerify 
    Agent
    StatusMain
    OtherDocuments 
    AllHeirs
    
    Balance
    EconomicUnites
    BonitetUnites 
    ExodusUnites     
    
    EconomicIndex
    PropertyUnites 
    IndexUnites 
    IndustryUnites 

    UnionInvestor
    CreditUnionBank
    CreditUnionBank2
    MarketUniten

    Bitcoin
    UniQum
    UniQumBonus
    UniQumCard
    AurexGold
    BitcoinWallet
    IsWithdrawal
    IsBSCWithdrawal
    HashTag
    
    IndividualCertificate

    start
    basic
    full

    TraiderInfo
    ActivationDate
    
    DateRegistration
    MyCertificates{
      Name
      DateStart
      Sum
      Cost
      ColorBase
      Profit
      DaysPassed
    }
    MerchantRequest {
      MerchantKey
      MerchantHash
      EuroSum
      submitted
      order_currency
      order_id
      status
      coin_amount
    }
    ExchangeHistory {
      date
      SumOut
      SumIn
      Direction
    }
  }
}
`;

export const GET_CURRENT_USER_AGENT = gql`
query($Agent: String){
  getCurrentUserAgent(Agent: $Agent){
    email 
    Balance
    Agent   
    Name
    Surname
    ETHWallet
    BSCWallet
    PostalCode
    City
    Address
    MobilePhone
    Skype
    TableReferal
    StatusMain
    DateRegistration
  }
}`;

export const GET_ONE_CLIENT = gql`
    query($email: String){
  getOneClient(email: $email){
    _id
    email
    Agent
    Name
    Surname
    ETHWallet
    BSCWallet
    Nationality
    Country
    PostalCode
    City
    Address
    MobilePhone
    Skype
    StatusMain
  }
}
`;

export const GET_ALL_TEXTS= gql`
    query{
  getAllTexts{
    _id
    PageName
    TextValue
    TextName
  }
}
`;


export const GET_ALL_VARIABLES= gql`
    query{
  getAllVariables{
    _id
    Name
    Value
  }
}
`;

export const GET_GLOBAL_INFO= gql`
   query($title:String!){
  getGlobalInfo(title: $title){
 	_id
    title
    InfoNumber
    }
  }
`;

export const ALL_HEIRS = gql`
mutation($email : String!, $AllHeirs: String){
    AllHeirs(email : $email, AllHeirs: $AllHeirs)
    {
        _id
        email
        AllHeirs
    }
}
`;


export const SEARCH_ELEMENT = gql`
query($searchItem: String){
  searchElement(searchItem: $searchItem){
    _id
    title
  }
}
`;


export const SELL_CERTIFICATE = gql`
mutation ($dateStart : Int!, $Cost: Float!){
  SellCertificate (dateStart : $dateStart, Cost: $Cost)
  {
        
    Balance
    EconomicUnites
    BonitetUnites 
    ExodusUnites  
    UniQumBonus 
    
    EconomicIndex
    IndexUnites 
    IndustryUnites 
    PropertyUnites 
        
    UnionInvestor
    CreditUnionBank
    CreditUnionBank2
    MarketUniten
    
    IndividualCertificate

    start
    basic
    full
  }
}
`;

export const ADD_ELEMENT = gql`
mutation ($title : String!, $text : String, $category : String, $up : Int){
  addElement (title : $title, text : $text, category : $category, up : $up)
  {
    _id
    title
    text
    category
    up
  }
}
`;

export const ADD_WITHDRAWAL_REQUEST = gql`
mutation($email : String!, $DateRegistration : String, $Sum : Float, $Result: String){
  addWithdrawalRequest(email : $email,DateRegistration : $DateRegistration, Sum : $Sum, Result: $Result)
  {
    _id
    email
    DateRegistration
    Sum 
    Result
  }
}

`;
export const ADD_EXODUS_REQUEST = gql`
mutation($email : String!,$Ammount : Int, $Type : String, $RequestStatus: String){
  addExodusRequest(email : $email,Ammount : $Ammount, Type : $Type, RequestStatus: $RequestStatus)
  {
    _id
    email
    Ammount
    Type 
    RequestStatus
  }
}

`;

export const EXODUS_CREATED = gql`
subscription {
  ExodusRequestCreated{
    _id
    email
    Ammount
    Type 
    RequestStatus
  }
}
`;

export const GET_ALL_EXODUS_REQUEST= gql`
query{
getAllExodusRequests{
    _id
  email
  Ammount
  Type
  RequestStatus  
  }
}
`;

export const GET_ALL_WITHDRAWAL_REQUEST_WITH_FILTER = gql`
query($email : String!, $TypeRequest : String){
  getAllWithdrawalRequestWithFilter(email : $email,TypeRequest : $TypeRequest)
  {
    _id
    email
    DateRegistration
    Sum 
    Result
  }
}

`;

export const BUY_UNITEN = gql`
mutation($email : String!, $WhatWePay : String!,$EconomicUnites: Float, $PropertyUnites  : Float, $IndexUnites  : Float, $IndustryUnites  : Float){
  buyUniten(email : $email,  WhatWePay : $WhatWePay,  EconomicUnites : $EconomicUnites, PropertyUnites  : $PropertyUnites, IndexUnites  : $IndexUnites, IndustryUnites  : $IndustryUnites)
  {
    email
    EconomicUnites
    PropertyUnites
    IndexUnites
    IndustryUnites
    Balance
    UniQumBonus
    BitcoinWallet
  }
}
`;

export const ADD_MERCHANT_REQUEST = gql`
mutation($email: String!, $MerchantKey: String, $MerchantHash: String, $EuroSum: String, $submitted: String, $order_currency: String, $order_id: String, $status: String, $coin_amount: Float){
  addMerchantRequest(email: $email, MerchantKey: $MerchantKey, MerchantHash: $MerchantHash, EuroSum: $EuroSum, submitted: $submitted, order_currency: $order_currency, order_id: $order_id, status: $status, coin_amount: $coin_amount)
  {
    MerchantRequest {
      MerchantKey
      MerchantHash
      EuroSum
      submitted
      order_currency
      order_id
      status
      coin_amount
    }
  }
}
`;

export const BIG_EXCHANGE = gql`
mutation($email : String!, $Sum: Float, $Direction : Boolean){
  bigExchange(email : $email,  Sum : $Sum,  Direction : $Direction)
  {
    email
    EconomicUnites
    Balance
    BitcoinWallet
    UniQumBonus
  }
}
`;

export const BIG_EXCHANGE_BTC = gql`
mutation($email : String!, $SumBTC: Float, $SumUniten: Float, $Direction : Boolean){
  bigExchangeBTC(email : $email, SumBTC : $SumBTC, SumUniten : $SumUniten, Direction : $Direction)
  {
    email
    EconomicUnites
    Balance
    BitcoinWallet
    UniQumBonus
  }
}
`;

export const UNITEN_DELETE = gql`
mutation($email : String!, $Sum: Float){
  unitenDelete(email : $email,  Sum : $Sum)
  {
    email
    EconomicUnites
    Balance
  }
}
`;

export const BUY_ELEMENT_ONE = gql`
mutation($email : String!, $WhatWePay : String!, $ElementName : String, $Sum : Float, $SumBTC : Float){
  buyElementOne(email : $email, WhatWePay : $WhatWePay, ElementName : $ElementName, Sum : $Sum, SumBTC : $SumBTC)
  {
    email
    UnionInvestor
    CreditUnionBank
    CreditUnionBank2
    MarketUniten
    Balance
    BitcoinWallet
    UniQumBonus
    start
    basic
    full
  }
}
`;
export const BUY_TRADING = gql`
mutation($email : String!, $WhatWePay : String!, $ElementName: String, $Sum  : Float){
  buyTrading(email : $email,  WhatWePay : $WhatWePay,  ElementName : $ElementName, Sum  : $Sum)
  {
    email
    Balance
  }
}
`;



export const SUB_BUY_UNITEN = gql`
subscription {
  SubBuyUniten{
    email
    Name
    Surname
    ETHWallet
    PostalCode
    City
    Address
    MobilePhone
    Skype
    IsAdmin
    TableReferal
    
    PassportVerify 
    AddressVerify 
    BerfusVerify
    Agent
    StatusMain
    OtherDocuments 
    AllHeirs
    
    Balance
    EconomicUnites
    BonitetUnites 
    ExodusUnites   
    
    EconomicIndex
    IndexUnites 
    IndustryUnites 
    PropertyUnites 
        
    UnionInvestor
    CreditUnionBank
    CreditUnionBank2
    MarketUniten
    
    IndividualCertificate

    HashTag

    start
    basic
    full

    UniQum
    UniQumBonus
    BitcoinWallet
    ExchangeHistory {
      date
      SumOut
      SumIn
      Direction
    }
  }
}
`;


export const UPDATE_USER = gql`
mutation ($email : String!, $NicName : String, $Name : String, $Surname : String, $Birthday : String,  $PostalCode : String, $City : String, $Address : String, $MobilePhone : String, $Skype : String, $ETHWallet : String, $BSCWallet : String, $IsWithdrawal: Boolean, $IsBSCWithdrawal: Boolean, $HashTag: String){
  updateUser (
    email : $email, NicName: $NicName, Name : $Name, Surname : $Surname, Birthday : $Birthday, PostalCode : $PostalCode, City : $City, Address : $Address, MobilePhone : $MobilePhone, Skype : $Skype, ETHWallet : $ETHWallet, BSCWallet : $BSCWallet, IsWithdrawal: $IsWithdrawal, IsBSCWithdrawal: $IsBSCWithdrawal, HashTag: $HashTag
  ) 
  {
    _id
    email
    NicName
    Name
    Surname
    Birthday
    ETHWallet
    BSCWallet
    PostalCode
    City
    Address
    MobilePhone
    Skype
    IsAdmin
    IsWithdrawal
    IsBSCWithdrawal
    HashTag
  }
}
`;

export const KYC_USER = gql`
mutation ($email : String!, $Name : String, $Surname : String, $Birthday : String, $PostalCode : String, $City : String, $Address : String, $Country : String, $Nationality : String){
  KYCUser (
    email : $email, Name : $Name, Surname : $Surname, Birthday : $Birthday, PostalCode : $PostalCode, City : $City, Address : $Address, Country : $Country, Nationality : $Nationality
  ) 
  {
    _id
    email
    Name
    Surname
    Birthday
    PostalCode
    City
    Address
    Country
    Nationality
  }
}
`;

export const ADD_KYC_DOC1 = gql`
mutation($userid : String!, $email : String!, $doc1: String){
  addKYCdoc1(userid: $userid, email : $email, doc1: $doc1)
    {
        _id
        user_id
        email
        doc1
    }
}
`;

export const ADD_KYC_DOC2 = gql`
mutation($userid : String!, $email : String!, $doc2: String){
  addKYCdoc2(userid: $userid, email : $email, doc2: $doc2)
    {
        _id
        user_id
        email
        doc2
    }
}
`;

export const ADD_KYC_DOC3 = gql`
mutation($email : String!, $selfie: String){
  addKYCdoc3(email : $email, selfie: $selfie)
    {
        _id
        email
        selfie
    }
}
`;

export const SAVE_KYC = gql`
mutation($email : String!, $start: Boolean, $doc_type: Int){
  saveKYC(email : $email, start: $start, doc_type: $doc_type)
    {
        _id
        email
        createdAt
        status
        start
        doc_type
        doc1
        doc2
        selfie
        status_doc1
        status_doc2
        status_selfie
    }
}
`;

export const GET_USER_KYC = gql`
query($email: String!){
  getUserKYC(email: $email)
  {
    _id
    email
    createdAt
    status
    status_check
    start
    doc_type
    doc1
    doc2
    selfie
    status_doc1
    status_doc2
    status_selfie
  }
}`;

export const UPDATE_USER_TRAIDER = gql`
mutation($email : String!, $TraiderInfo: String){
  updateUserTrading(email : $email, TraiderInfo: $TraiderInfo)
    {
        _id
        email
        TraiderInfo
  }}
`;

export const CHANGE_PASSWORD = gql`
mutation($email : String!, $password: String!, $passwordOld: String!){
    changePassword(email : $email, password: $password, passwordOld: $passwordOld)
    {
        _id
        email
        password
  }}
`;

export const RECOVERY_PASSWORD = gql`
mutation($email : String!){
    recoveryPassword(email : $email)
    {
        _id
        email
  }}
`;

export const CHANGE_GLOBAL_INFO = gql`
mutation($title : String!, $AddNumber : Int){
    changeGlobalInfo(title : $title, AddNumber: $AddNumber)
    {
     _id
     title
     InfoText
     InfoNumber
  }}
`;

export const SIGNIN_USER = gql`
mutation ($email : String!, $password : String!){
  signinUser (
    email : $email, password : $password
  ) 
  {
    token
  }
}
`;

export const SIGNUP_USER = gql`
mutation ($email : String!, $MobilePhone : String, $Name : String, $Surname : String, $password : String!, $StatusMain : String, $Agent : String, $Referrer : String, $BSCWallet: String){
  signupUser (
    email : $email, MobilePhone : $MobilePhone, Name : $Name, Surname : $Surname, password : $password, StatusMain : $StatusMain, Agent : $Agent, Referrer : $Referrer, BSCWallet: $BSCWallet
  )
  {
    token
  }
}
`;

export const GET_ALL_POSTS= gql`
    query{
  getAllPosts{
    _id
    createdAt
    updatedAt
    isPublished
    title
    text
    picture
  }
}
`;

export const GET_LAST_NEWS = gql`
    query{
  getLastNews{
    _id
    createdAt
    updatedAt
    isPublished
    title
    text
    picture
  }
}
`;

export const GET_CURRENT_NEW = gql`
query($_id: String!){
  getCurrentNew(_id: $_id)
  {
    _id
    id
    createdAt
    updatedAt
    isPublished
    title
    text
    picture
  }
}`;

export const GET_USER_CERTIFICATES = gql`
query($email: String){
  getUserCertificates(email: $email)
  {
    _id
    id
    userid
    email
    agent
    Name
    Sum
    DateStart
    ActivationDate
    Cost
    DaysPassed
    LastUpdate
    ColorBase
    Profit
    CashBonus
    CertNumber
    DistrBonus
  }
}`;

export const GET_CURRENT_CERTIFICATE = gql`
query($id: String){
  getCurrentCertificate(id: $id)
  {
    _id
    id
    userid
    email
    agent
    Name
    Sum
    DateStart
    ActivationDate
    Cost
    DaysPassed
    LastUpdate
    ColorBase
    Profit
    CashBonus
    CertNumber
    DistrBonus
  }
}`;

export const GET_AGENT_REFFERAL_CERTIFICATES = gql`
query($id: String){
  getAgentRefferalCertificate(id: $id)
  {
    _id
   id
   userid
   email
   agent
   UserName
   Product
   invested
   unix
   unixCoin
   bonus
   exodus
   exodusCoin
   halfmount
   iterationDo
   iterationNeed
   ActivationDate
   CashBonus
   time
  }
}`;

export const GET_USER_REFFERAL_CERTIFICATES = gql`
query($email: String){
  getUserRefferalCertificate(email: $email)
  {
    _id
   id
   userid
   email
   agent
   UserName
   Product
   invested
   unix
   unixCoin
   bonus
   exodus
   exodusCoin
   halfmount
   iterationDo
   iterationNeed
   ActivationDate
   CashBonus
   time
  }
}`;

export const BUY_NEW_CERTIFICATE = gql`
mutation($email : String!, $WhatWePay : String, $ElementName : String, $Sum : Float, $SumBTC : Float){
  buyUserNewCertificate(email : $email, WhatWePay : $WhatWePay, ElementName : $ElementName, Sum : $Sum, SumBTC : $SumBTC)
  {
    email    
    Balance
    EconomicUnites
    start
    basic
    full
    IndividualCertificate
  }
}
`;

export const ADD_NEW_OFFER = gql`
mutation($email : String!, $agent : String, $arno : Float, $ammount : Float, $coin_ammount: Float, $status : String, $request_id : String, $item_name : String, $currency1 : String, $currency2 : String, $status_url : String, $payment_time : String){
  addNewOffer(email : $email, agent: $agent, arno: $arno, ammount: $ammount, coin_ammount: $coin_ammount, status: $status, request_id: $request_id, item_name: $item_name, currency1: $currency1, currency2: $currency2, status_url: $status_url, payment_time: $payment_time)
    {
        _id
        email
        agent
        arno
        ammount
        coin_ammount
        status
        request_id
        item_name
        currency1
        currency2
        status_url
        payment_time
  }}
`;

export const GET_USER_OFFERS = gql`
query($email: String){
  getCurrentUserOffers(email: $email)
  {
      _id
      email
      agent
      arno
      ammount
      coin_ammount
      status
      request_id
      item_name
      currency1
      currency2
      status_url
      payment_time
  }
}`;

export const GET_AGENT_OFFERS = gql`
query($email: String){
  getCurrentAgentOffers(email: $email)
  {
      _id
      email
      agent
      arno
      ammount
      coin_ammount
      status
      request_id
      item_name
      currency1
      currency2
      status_url
      payment_time
  }
}`;

export const DELETE_OFFER = gql`
mutation($_id: ID){
  deleteOffer(_id: $_id)
    {
      _id
    }
}
`;

export const ADD_PAYPAL_REQUEST = gql`
mutation($email : String, $agent: String, $arno : Float, $value : Float, $currency : String, $request_id : String, $intent : String, $status : String, $item_name : String, $create_time : String, $pay_link : String){
  addPayPalRequest(email: $email, agent: $agent, arno: $arno, value: $value, currency: $currency, request_id: $request_id, intent: $intent, status: $status, item_name: $item_name, create_time: $create_time, pay_link: $pay_link){
    email
    agent
    arno
    value
    currency
    request_id
    intent
    status
    item_name
    create_time
    pay_link
  }
}`;

export const GET_PAYPAL_REQUEST = gql`
query($email: String){
  getPayPalRequest(email: $email){
    email
    arno
    value
    currency
    request_id
    intent
    status
    item_name
    create_time
    pay_link
  }
}`;

export const ADD_PAYEER_REQUEST = gql`
mutation($email : String, $agent: String, $arno : Float, $value : Float, $currency : String, $request_id : String, $status : String, $item_name : String, $create_time : String, $pay_link : String){
  addPayeerRequest(email: $email, agent: $agent, arno: $arno, value: $value, currency: $currency, request_id: $request_id, status: $status, item_name: $item_name, create_time: $create_time, pay_link: $pay_link){
    email
    agent
    arno
    value
    currency
    request_id
    status
    item_name
    create_time
    pay_link
  }
}`;

export const GET_PAYEER_REQUEST = gql`
query($email: String){
  getPayeerRequest(email: $email){
    email
    arno
    value
    currency
    request_id
    status
    item_name
    create_time
    pay_link
  }
}`;

export const GET_ONE_RATES = gql`
query($Name: String!){
  getOneRates(Name: $Name){
    _id
    Name
    Value
  }
}`

export const GET_USER_STEAKING = gql`
query($email: String!){
  getUserSteaking(email: $email){
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
  }
}`

export const GET_STEAKING_COINS = gql`
query{
  getSteakingCoins{
    allToken
    availableToken
    profit
  }
}`

export const GET_USER_STEAKING_COINS = gql`
query($email: String!){
  getUserSteakingCoins(email: $email){
    steakingCoins
  }
}`

export const CREATE_STEAKING = gql`
mutation($email: String, $name: String, $surname : String, $deposit : Float){
  createSteaking(email: $email, name: $name, surname: $surname, deposit: $deposit){
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
  }
}`;

export const GET_CURRENT_STEAKING = gql`
query($steakid: String!){
  getCurrentSteaking(steakid: $steakid){
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
  }
}`

export const UPDATE_STEAKING = gql`
mutation($steakid: String!, $deposit : Float){
  updateSteaking(steakid: $steakid, deposit: $deposit){
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
  }
}`;


export const CLOSE_STEAKING = gql`
mutation($steakid: String!){
  closeSteaking(steakid: $steakid){
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
  }
}`;



